import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "giftFilled"
const GiftFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M11.25 14.25V22.5H4.5C3.672 22.5 3 21.828 3 21V14.25zM21 14.25V21C21 21.828 20.328 22.5 19.5 22.5H12.75V14.25z" />
          <path
            fillRule="evenodd"
            d="M5.974 2.598C7.438 1.134 9.812 1.134 11.276 2.598 11.883 3.204 12.173 4.278 12.308 5.38 12.422 4.964 12.585 4.59 12.815 4.314L12.915 4.204C14.03 3.087 15.838 3.087 16.953 4.203L17.055 4.308C17.862 5.203 17.99 6.474 17.46 7.5H20.25C21.078 7.5 21.75 8.173 21.75 9V12.75H12.75V7.876H11.25V12.75H2.25V9C2.25 8.172 2.922 7.5 3.75 7.5H5.672C4.542 6.033 4.628 3.943 5.974 2.598M10.216 3.658C9.337 2.78 7.913 2.78 7.034 3.658 6.17 4.523 6.168 5.922 7.061 6.814 7.17 6.924 7.43 7.084 7.92 7.226 8.396 7.361 8.966 7.446 9.568 7.49L9.717 7.5H10.916C10.92 7.102 10.912 6.654 10.88 6.17 10.837 5.564 10.756 4.99 10.622 4.516 10.483 4.022 10.323 3.766 10.216 3.658M15.893 5.264C15.363 4.734 14.505 4.734 13.975 5.264 13.955 5.284 13.855 5.413 13.758 5.76 13.665 6.091 13.606 6.5 13.575 6.948Q13.555 7.238 13.55 7.5H14.83Q15.126 7.454 15.37 7.383C15.718 7.284 15.85 7.184 15.872 7.161 16.416 6.617 16.408 5.779 15.892 5.264"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default GiftFilledIcon
